import { defineStore } from 'pinia'
import { useApi } from '~/composables/useApi'
import { useDestinationsStore } from '~/stores/destinations'

export const useComparisonStore = defineStore('comparison', {
  state: () => ({
    comparison: {
      loading: false,
      data: {},
    },

    comparisons: {
      loading: false,
      data: {},
    },

    loadingVenues: false,
    venue1: null,
    venue2: null,
  }),

  actions: {
    async loadComparison (permalink) {
      this.comparison.loading = true
      try {
        const resp = await useApi(`comparisons/${permalink}`, {
          query: {
            destination_permalink: useDestinationsStore().destination.data.permalink,
          },
        })
        this.comparison.data = resp.response.comparison
        return this.comparison.data
      } finally {
        this.comparison.loading = false
      }
    },

    async loadComparisons () {
      this.comparisons.loading = true
      try {
        const resp = await useApi('comparisons', {
          query: {
            venue_id: this.venue1.id,
          },
        })
        this.comparisons.data = resp.response.comparisons
        return this.comparisons.data
      } finally {
        this.comparisons.loading = false
      }
    },

    async loadVenues () {
      this.loadingVenues = true
      try {
        const resp = await useApi(`venues/${this.comparison.data.venue_1_id},${this.comparison.data.venue_2_id}`, {
          query: {
            extended_info: true,
          },
        })
        this.venue1 = resp.response.venues[0]
        this.venue2 = resp.response.venues[1]
        return [this.venue1, this.venue2]
      } finally {
        this.loadingVenues = false
      }
    },

    async loadVenue1 (path) {
      this.loadingVenues = true
      try {
        const resp = await useApi('venues/show', {
          query: {
            path,
            extended_info: true,
          },
        })
        this.venue1 = resp.response.venues[0] || {}
      } finally {
        this.loadingVenues = false
      }
    },
  },
})
